import Cookies from 'js-cookie';
import { useMemo } from 'react';

export function getCookie(name: string): string | undefined {
  // Avoid private storage errors
  try {
    return Cookies.get(name);
  } catch {
    return undefined;
  }
}

export function setCookie(
  name: string,
  value: string,
  options?: Cookies.CookieAttributes,
): void {
  Cookies.set(name, value, options);
}

export function deleteCookie(name: string): void {
  Cookies.remove(name);
}

export function useCookie(name: string): string | undefined {
  return useMemo(() => getCookie(name), [name]);
}
